var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title:
          _vm.nextDueDate +
          " - " +
          _vm.$t("mandate.total") +
          " : " +
          (_vm.listItemsPaymentSchedule.length > 0
            ? _vm.formatCurrency(_vm.listItemsPaymentSchedule[0].Total)
            : _vm.formatCurrency(0)),
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mt-3 align-items-center" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("back-button", {
                        staticClass: "btnFilter_2 mr-2 btn-back",
                        attrs: { returnUrl: _vm.returnUrl },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "mx-auto" }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "mx-auto mb-4", attrs: { cols: "12" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { overflow: "auto" } },
                        [
                          _vm.activateSpinner
                            ? _c("spinner")
                            : _vm.listItemsPaymentSchedule.length > 0
                            ? _c("b-table", {
                                key: _vm.refreshKey,
                                staticClass: "table table-striped",
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  striped: "",
                                  hover: "",
                                  responsive: "",
                                  items: _vm.listItemsPaymentSchedule,
                                  fields: _vm.fields,
                                  "sort-by": _vm.sortBy,
                                  "sort-desc": _vm.sortDir,
                                  "empty-text": _vm.$t(
                                    "common.security.no_result"
                                  ),
                                },
                                on: {
                                  "update:sortBy": function ($event) {
                                    _vm.sortBy = $event
                                  },
                                  "update:sort-by": function ($event) {
                                    _vm.sortBy = $event
                                  },
                                  "update:sortDesc": function ($event) {
                                    _vm.sortDir = $event
                                  },
                                  "update:sort-desc": function ($event) {
                                    _vm.sortDir = $event
                                  },
                                  "head-clicked": _vm.sortTable,
                                  "row-clicked": _vm.onRowClicked,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "cell(amount)",
                                    fn: function (data) {
                                      return [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.formatCurrency(
                                                data.item.amount
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(frequency)",
                                    fn: function (data) {
                                      return [
                                        data.value !== ""
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "mandate.frequency_type_" +
                                                      data.value
                                                  )
                                                )
                                              ),
                                            ])
                                          : _c("span", [_vm._v("-")]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(nextDueDate)",
                                    fn: function (data) {
                                      return [
                                        data.value !== ""
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatDate(
                                                      data.item.nextDueDate
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _c("span", [_vm._v("-")]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(status)",
                                    fn: function (data) {
                                      return [
                                        data.value !== ""
                                          ? _c(
                                              "span",
                                              {
                                                class: [
                                                  "chip",
                                                  "chip--" +
                                                    _vm.statusVariant(data),
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.status_payment_schedule_" +
                                                        data.value
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c("span", [_vm._v("-")]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(StatusCollection)",
                                    fn: function (data) {
                                      return [
                                        data.value !== ""
                                          ? _c(
                                              "span",
                                              {
                                                class: [
                                                  "chip",
                                                  "chip--" +
                                                    _vm.statusVariantCollection(
                                                      data
                                                    ),
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.status_collection_" +
                                                        data.value
                                                    )
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                class: [
                                                  "chip",
                                                  "chip--" +
                                                    _vm.statusVariantCollection(
                                                      data
                                                    ),
                                                ],
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "mandate.status_collection_not_created"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(actions)",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "b-link",
                                          {
                                            staticClass: "text-decoration-none",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.onRowClicked(item)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("mandate.view_details")
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "d-flex justify-content-center",
                                },
                                [
                                  _c("span", { staticClass: "noResult" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("common.no_result")) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-5" },
                [
                  _c(
                    "b-col",
                    [
                      _c("cm-pagination", {
                        attrs: {
                          maxResultsByPage: _vm.paginationObject.maxResults,
                          firstIndex: _vm.paginationObject.firstIndex,
                          nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                          refreshEvent: _vm.paginationObject.refresh,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }